/* istanbul ignore next */

function vehicleMediaGallery() {
    const vehicleMediaGallery = document.getElementById('vehicleMediaGallery');

    const imageDisplayControls = document.getElementById('imageDisplayControls');

    const videoPlayer = document.getElementById('videoPlayer');
    const galleryImage = document.getElementById('galleryImage');
    const spinCarButton = document.getElementById('inject-spincar');

    const activeThumbClass = 'gallery-controls__thumbnail-image--selected';
    const activeVideoButtonClass = 'media-gallery__button--video-selected';
    const videoPlayerActiveClass = 'media-gallery--video-player-active';
    const spinCarActiveClass = 'media-gallery--spincar-active';

    const nextThumbnailSetDisabledClass = 'media-gallery__button--thumbnail-next--disabled';
    const previousThumbnailSetDisabledClass = 'media-gallery__button--thumbnail-previous--disabled';

    let thumbnailContainer;
    let videoPlayerButton;
    let activeImageSelected;
    let firstThumbImage;
    let lastThumbImage;
    let imageDisplayActive = false;
    let videoPlayerActive = false;
    let spinCarActive = false;

    if (imageDisplayControls) {

        imageDisplayActive = true;
        thumbnailContainer = document.body.querySelector('.gallery-controls__thumbnail-container');
        const nextImageBtn = document.getElementById('nextImageBtn');
        const prevImageBtn = document.getElementById('prevImageBtn');
        const thumbImages = document.querySelectorAll('.gallery-controls__thumbnail-image');
        const nextThumbnailSet = document.getElementById('nextThumbnailSet');
        const previousThumbnailSet = document.getElementById('previousThumbnailSet');

        firstThumbImage = thumbImages[0];
        lastThumbImage = thumbImages[thumbImages.length - 1];
        for (let i = 0; i < thumbImages.length; i++) {
            if (i === 0) {
                activeImageSelected = thumbImages[i];
                activeImageSelected.classList.add(activeThumbClass);
            }
            thumbImages[i].addEventListener('click', (event) => imageThumbClick(event));
        }

        nextImageBtn.addEventListener('click', () => imageDisplayControlsClick('next'));
        prevImageBtn.addEventListener('click', () => imageDisplayControlsClick('previous'));

        nextThumbnailSet.addEventListener('click', function(){
            thumbnailContainer.scrollLeft += thumbnailContainer.offsetWidth;
        });

        previousThumbnailSet.addEventListener('click', function(){
            thumbnailContainer.scrollLeft -= thumbnailContainer.offsetWidth;
        });

        loadBackgroundImages();
        swipedetect(imageDisplayControls, function (swipedir) {
            if ( swipedir !== "none" ) {
                imageDisplayControlsClick(swipedir);
            }
        });

        thumbnailContainer.addEventListener('scroll', () => setPaginationButtonState(event), { passive: true } );
        const thumbnails = document.querySelectorAll(".gallery-controls__thumbnail-image");
        let largeImages = [];
        for (let i = 0; i < thumbnails.length; i++) {
            largeImages[i] = new Image();
            largeImages[i].src = thumbnails[i].dataset.image;
        }
    }

    if (spinCarButton) {
        let spinCar = window.document.createElement('script');
        spinCar.setAttribute('src', "//cars-dot-com.swipetospin.com");
        vehicleMediaGallery.appendChild(spinCar);
        spinCarButton.addEventListener('click', (event) => displaySpinCar(event));
    }

    if (videoPlayer) {
        videoPlayerButton = document.getElementById('videoPlayerButton');
        videoPlayerButton.addEventListener('click', (event) => videoPlayerClick(event));
    }

    function imageDisplayControlsClick(direction) {
        const clicked = direction;
        activeImageSelected.classList.remove(activeThumbClass);

        if (clicked === 'next') {
            if (activeImageSelected === lastThumbImage) {
                activeImageSelected = firstThumbImage;
            } else {
                activeImageSelected = activeImageSelected.nextElementSibling;
            }
        } else {
            if (activeImageSelected === firstThumbImage) {
                activeImageSelected = lastThumbImage;
            } else {
                activeImageSelected = activeImageSelected.previousElementSibling;
            }
        }
        scrollThumbnail(direction);
        setPhotoGalleryImage();
    }

    function imageThumbClick(event) {
        activeImageSelected.classList.remove(activeThumbClass);
        activeImageSelected = event.currentTarget;
        resetMediaPanels();
        setPhotoGalleryImage();
    }

    function resetMediaPanels(){
        if (videoPlayerActive) {
            videoPlayerButton.classList.remove(activeVideoButtonClass);
            vehicleMediaGallery.classList.remove(videoPlayerActiveClass);
            videoPlayerActive = false;
            toggleIframeSrc(false);
        }
        if (spinCarActive) {
            spinCarActive = false;
            vehicleMediaGallery.classList.remove(spinCarActiveClass);
        }
        if (imageDisplayActive) {
            activeImageSelected.classList.remove(activeThumbClass);
            imageDisplayActive = false;
        }
    }

    function scrollThumbnail(direction) {
        if ("IntersectionObserver" in window) {
            let thumbnailObserver = new IntersectionObserver(function (thumbnail) {
                if (!thumbnail[0].isIntersecting) {
                    thumbnailContainer.scrollTo(thumbnail[0].target.offsetLeft - activeImageSelected.offsetWidth / 2, 0);
                }
                thumbnailObserver.unobserve(thumbnail[0].target);
            });
            thumbnailObserver.observe(activeImageSelected);
        } else {
            if (activeImageSelected === lastThumbImage) {
                thumbnailContainer.scrollTo(2000, 0);
            } else if (activeImageSelected === firstThumbImage) {
                thumbnailContainer.scrollTo(0, 0);
            } else if (direction == "next") {
                thumbnailContainer.scrollLeft += activeImageSelected.offsetWidth;
            } else if (direction == "previous") {
                thumbnailContainer.scrollLeft -= activeImageSelected.offsetWidth;

            }
        }
    }

    function displaySpinCar() {
        resetMediaPanels();
        spinCarActive = true;
        vehicleMediaGallery.classList.add(spinCarActiveClass);
    }

    function setPhotoGalleryImage() {
        galleryImage.src = activeImageSelected.dataset.image;
        activeImageSelected.classList.add(activeThumbClass);
    }

    function videoPlayerClick(e) {
        const videoId = e.currentTarget.dataset.videourl;
        const alsImpression = JSON.parse(e.currentTarget.dataset.alsImpressionData);

        alsImpression.publicConsumerId = CARS.digitalData.user.profileInfo.publicConsumerId;
        alsImpression.publicDeviceId =  CARS.digitalData.user.profileInfo.publicDeviceId;

        if (pageStateExists()) {
            window.CARS.PageState.push('event', {
                eventDetail: 'vehicle-video-play',
                eventName: 'video-play'
            }, true);
        }
        activeImageSelected.classList.remove(activeThumbClass);
        resetMediaPanels();
        videoPlayerActive = true;
        videoPlayerButton.classList.add(activeVideoButtonClass);
        vehicleMediaGallery.classList.add(videoPlayerActiveClass);
        toggleIframeSrc(true, videoId);
        sendAlsImpression('POST', '/ajax/a773a9c189a3ff4/1.0/impression', JSON.stringify(alsImpression), "application/json").then(data => {}).catch((e) => console.log("error", e));
    }

    function toggleIframeSrc(isSrc, data) {
        isSrc ? videoPlayer.setAttribute('src', data) : videoPlayer.setAttribute('src', '');
    }

    function loadBackgroundImages() {
        var thumbnails = document.querySelectorAll(".gallery-controls__thumbnail-image");
        if ("IntersectionObserver" in window) {
            let thumbnailObserver = new IntersectionObserver(function (thumbnails) {
                thumbnails.forEach(function (thumbnail) {
                    if (thumbnail.isIntersecting) {
                        const thumbnailImage = thumbnail.target.dataset.thumb;
                        thumbnail.target.style.backgroundImage = "url(" + thumbnailImage + ")";
                        thumbnailObserver.unobserve(thumbnail.target);
                    }
                });
            });
            thumbnails.forEach(function (thumbnail) {
                thumbnailObserver.observe(thumbnail);
            });
        } else {
            for ( var i = 0; i < thumbnails.length; i++ ) {
                const currentThumb = thumbnails[i].dataset.thumb;
                thumbnails[i].style.backgroundImage = "url(" + currentThumb + ")";
            }
        }
    }

    function swipedetect(el, callback) {

        var touchsurface = el,
            swipedir,
            startX,
            startY,
            distX,
            distY,
            threshold = 50,
            restraint = 200,
            allowedTime = 200,
            elapsedTime,
            startTime,
            handleswipe = callback || function (swipedir) {};

        touchsurface.addEventListener('touchstart', function (e) {
            var dist = 0;
            var touchobj = e.changedTouches[0];
            swipedir = 'none';
            startX = touchobj.pageX;
            startY = touchobj.pageY;
            startTime = new Date().getTime();
            e.preventDefault();
        },{passive: true});

        touchsurface.addEventListener('touchmove', function (e) {
            e.preventDefault();
        }, {
            passive: true
        });

        touchsurface.addEventListener('touchend', function (e) {
            var touchobj = e.changedTouches[0];
            distX = touchobj.pageX - startX;
            distY = touchobj.pageY - startY;
            elapsedTime = new Date().getTime() - startTime;
            if (elapsedTime <= allowedTime) {
                if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint) {
                    swipedir = (distX < 0) ? 'next' : 'previous';
                } else if (Math.abs(distY) >= threshold && Math.abs(distX) <= restraint) {
                    e.preventDefault();
                }
            }
            handleswipe(swipedir);
            e.preventDefault();
        }, {
            passive: true
        });
    }

    function sendAlsImpression(method, url, data = "", header = "") {
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open(method, url);
            xhr.setRequestHeader("Content-Type", header);
            xhr.onload = function () {
                if (xhr.status === 200) {
                    resolve(xhr.response);
                } else {
                    reject(Error(xhr.statusText));
                }
            };
            xhr.onerror = reject;
            xhr.send(data);
        });
    }

    function setPaginationButtonState(event) {
        if (event.currentTarget.offsetWidth + event.currentTarget.scrollLeft == event.currentTarget.scrollWidth) {
            nextThumbnailSet.classList.add(nextThumbnailSetDisabledClass);
        } else if (event.currentTarget.scrollLeft == 0) {
            previousThumbnailSet.classList.add(previousThumbnailSetDisabledClass);
        } else {
            nextThumbnailSet.classList.remove(nextThumbnailSetDisabledClass);
            previousThumbnailSet.classList.remove(previousThumbnailSetDisabledClass);
        }
    }

    function pageStateExists() {
        return !!(window.CARS && window.CARS.PageState && window.CARS.digitalData);
    }

}

export default vehicleMediaGallery;
